import DIYPricing from "./DIYPricing";

export default DIYPricing;
